import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { HighlightOff } from '@mui/icons-material';
import { Button } from '@qrios/frontend-library';

import errors from '../../../../../../constants/errors';
import { formatDate, TABLE_DATE_TIME_FORMAT } from '../../../../../../constants/helpers/dates';

import DetailItem from '../detailItem';
import DetailsFactory from './detailsFactory';
import { FailedReport, ReportMetadata } from '../../../interfaces';
import { HandleOpenDeleteDialog, HandleOpenRetryDialog } from '../../interfaces';

interface Props {
  report: FailedReport;
  generationAllowed: boolean;
  handleOpenDeleteDialog: HandleOpenDeleteDialog;
  handleOpenRetryDialog: HandleOpenRetryDialog;
  handleCloseDetailsDialog: () => void;
  appliedFilters: (filters: ReportMetadata) => ReactNode;
}
const FailedDetails = ({
  report,
  handleOpenDeleteDialog,
  handleOpenRetryDialog,
  handleCloseDetailsDialog,
  appliedFilters,
  generationAllowed
}: Props) => {
  const theme = useTheme();

  return (
    <DetailsFactory
      action={{
        icon: { component: HighlightOff, color: theme.palette.error.main },
        // eslint-disable-next-line max-len
        text: `An error occurred during report generation and could not be created. Please try again and contact support in case of further problems.${
          generationAllowed ? '' : errors.inReportsDetailsLimitReachedMsg('retry')
        }`,
        content: (
          <>
            <Box width="100%" mb={2} mt={2}>
              <Button
                fullWidth
                disabled={!generationAllowed}
                onClick={() => {
                  handleOpenRetryDialog(report);
                  handleCloseDetailsDialog();
                }}
                data-testid="button-retry-report-generation"
                text="Retry report generation"
              />
            </Box>
            <Box width="100%">
              <Button
                fullWidth
                onClick={() => {
                  handleOpenDeleteDialog(report);
                  handleCloseDetailsDialog();
                }}
                text="Delete report"
                danger
                data-testid="button-delete-report"
              />
            </Box>
          </>
        )
      }}
      metaContent={<DetailItem label="Ordered date" value={formatDate(report.orderDate, TABLE_DATE_TIME_FORMAT)} />}
      filtersContent={<DetailItem label="Applied Filters" value={appliedFilters(report.metadata)} />}
    />
  );
};

export default FailedDetails;
